// @flow
import { combineReducers } from 'redux';
import * as types from '../types/buses';
import * as common from './common';
import type { ERROR_TYPE } from '../types/common';
import type { BUS_TYPE } from '../types/buses';

export type BusesState = {
  byId: { [number]: BUS_TYPE },
  fetching: Array<number>,
  order: Array<number>,
  isFetching: boolean,
  errors: { [number]: ERROR_TYPE },
  current: number,
  searchFilter: string,
};

const byId = common.byId({
  added: [
    types.BUS_FETCH_SUCCEED,
    types.BUS_CREATE_SUCCEED,
    types.FETCH_SCHOOl_BUSES_SUCCESS,
  ],
  updated: [
    types.BUS_UPDATED,
    types.BUS_UPDATED_LAST_CONNECTION,
    types.UPDATE_BUS_SUCCEED,
  ],
  fetched: [
    types.BUSES_REGISTERED,
    types.BUS_CREATE_SUCCEED,
    types.FETCH_SCHOOl_BUSES_SUCCESS,
  ],
  removed: [types.BUS_REMOVED, types.DELETE_BUS_SUCCESS],
  defaultAttributes: {
    location: {
      latitude: 0,
      longitude: 0,
    },
  },
});

const order = common.order({
  added: [
    types.BUS_CREATE_SUCCEED,
    types.FETCH_SCHOOl_BUSES_SUCCESS,
  ],
  fetched: [
    types.BUSES_REGISTERED,
    types.BUS_CREATE_SUCCEED,
    types.FETCH_SCHOOl_BUSES_SUCCESS,
  ],
  removed: [types.BUS_REMOVED, types.DELETE_BUS_SUCCESS],
  cleared: [types.BUS_FILTERS_CHANGED],
});

const fetching = common.fetching({
  started: [types.BUS_FETCH_STARTED, types.BUS_CREATE_STARTED],
  failed: [types.BUS_FETCH_FAILED, types.BUS_CREATE_FAILED],
  succeed: [types.BUS_FETCH_SUCCEED, types.BUS_CREATE_SUCCEED],
});

const errors = common.errors({
  populate: [types.BUS_FETCH_FAILED, types.BUS_CREATE_FAILED, types.DELETE_BUS_FAILED],
  clear: [types.BUS_FETCH_SUCCEED, types.BUS_CREATE_SUCCEED],
});

const isFetching = common.isFetching({
  started: [
    types.DELETE_BUS_STARTED,
    types.FETCH_SCHOOl_BUSES_STARTED,
  ],
  failed: [types.DELETE_BUS_FAILED, types.FETCH_SCHOOl_BUSES_FAILED],
  succeed: [types.DELETE_BUS_SUCCESS, types.FETCH_SCHOOl_BUSES_SUCCESS],
});

const current = common.mux({
  selected: [types.BUS_SELECTED],
  default: -1,
});

const searchFilter = common.singleton({
  populate: [types.BUS_FILTERS_CHANGED],
  clear: [],
});

const buses = combineReducers({
  byId,
  order,
  fetching,
  errors,
  isFetching,
  current,
  searchFilter,
});

export default buses;

export const getBus = (state: BusesState, id: number): BUS_TYPE => state.byId[id];
export const getBusIsFetching = (state: BusesState): boolean => state.isFetching;
export const getBuses = (
  state: BusesState,
): Array<BUS_TYPE> => state.order.map(id => state.byId[id]);
export const isBusFetching = (
  state: BusesState,
  id: number,
): boolean => state.fetching.includes(id);
export const getBusError = (state: BusesState, id: number): ERROR_TYPE => state.errors[id];
export const getBusLocation = (
  state: BusesState,
  id: number,
): { latitude: number, longitude: number } => state.byId[id].location;
export const getCurrentBus = (state: BusesState): BUS_TYPE => getBus(state, state.current);
export const getBusSearchFilter = (state: BusesState): string => state.searchFilter;



// WEBPACK FOOTER //
// ./src/scripts/reducers/buses.js